import type { FC, Ref } from "react"
import type { EChartsReactProps } from "echarts-for-react"
import ReactEcharts from "echarts-for-react"

const contrastColor = "rgba(255, 255, 255, 1)"
const textStyleColor = "rgba(198, 198, 207, 1)"

const axisCommon = function () {
  return {
    axisLine: {
      lineStyle: {
        color: contrastColor,
      },
    },
    axisTick: {
      lineStyle: {
        color: contrastColor,
      },
    },
    axisLabel: {
      textStyle: {
        color: textStyleColor,
      },
    },
    splitLine: {
      lineStyle: {
        // type: "dashed",
        color: "#aaa",
      },
    },
    splitArea: {
      areaStyle: {
        color: contrastColor,
      },
    },
  }
}

const colorPalette = [
  "rgba(91, 143, 249, 0.85)",
  "rgba(90, 216, 166, 0.85)",
  "rgba(189, 239, 219, 0.85)",
  "rgba(93, 112, 146, 0.85)",
  "rgba(194, 200, 213, 0.85)",
  "rgba(246, 189, 22, 0.85)",
  "rgba(251, 229, 162, 0.85)",
  "rgba(232, 104, 74, 0.85)",
  "rgba(246, 195, 183, 0.85)",
  "rgba(109, 200, 236, 0.85)",
]
const theme_my = {
  color: colorPalette,
  //   backgroundColor: "#393f5a",
  tooltip: {
    axisPointer: {
      lineStyle: {
        color: contrastColor,
      },
      crossStyle: {
        color: contrastColor,
      },
      label: {
        color: "#000",
      },
    },
  },
  legend: {
    textStyle: {
      color: textStyleColor,
    },
  },
  textStyle: {
    color: textStyleColor,
  },
  title: {
    textStyle: {
      color: textStyleColor,
    },
  },
  toolbox: {
    iconStyle: {
      normal: {
        borderColor: textStyleColor,
      },
    },
  },
  dataZoom: {
    textStyle: {
      color: textStyleColor,
    },
  },
  visualMap: {
    textStyle: {
      color: textStyleColor,
    },
  },
  timeline: {
    lineStyle: {
      color: textStyleColor,
    },
    itemStyle: {
      normal: {
        color: colorPalette[1],
      },
    },
    label: {
      normal: {
        textStyle: {
          color: textStyleColor,
        },
      },
    },
    controlStyle: {
      normal: {
        color: textStyleColor,
        borderColor: textStyleColor,
      },
    },
  },
  timeAxis: axisCommon(),
  logAxis: axisCommon(),
  valueAxis: axisCommon(),
  categoryAxis: axisCommon(),

  line: {
    symbol: "circle",
  },
  graph: {
    color: colorPalette,
  },
  gauge: {
    title: {
      textStyle: {
        color: textStyleColor,
      },
    },
  },
  candlestick: {
    itemStyle: {
      normal: {
        color: "#FD1050",
        color0: "#0CF49B",
        borderColor: "#FD1050",
        borderColor0: "#0CF49B",
      },
    },
  },
}

// theme.categoryAxis.splitLine.show = false

type ChartOption = EChartsReactProps &
  Partial<{
    $ref?: Ref<any>
  }>

const Chart: FC<ChartOption> = ({ option, className = "", theme = theme_my, $ref, onEvents }) => {
  return (
    <ReactEcharts
      ref={$ref}
      option={option}
      notMerge={true}
      lazyUpdate={true}
      theme={theme}
      className={className}
      style={{ width: "100%", height: "100%" }}
      onEvents={onEvents}
    />
  )
}

export default Chart
